import React from 'react';

export default class ItemMensagem extends React.Component{
  render(){
    const dados = this.props.data;
    console.log(dados);
    return(
      <div className='item-listagem' data-id={dados.id}>
        <a href='#' className='bt-mensagem' onClick={this.props.onClickHandler}>
          <div className=' bt-mensagem-data'>{dados.data}</div>
          <div>{dados.de}</div>
          <div className='bt-mensagem-assunto'>{dados.assunto}</div>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/mensagens/ItemMensagem.js